import { S } from './ModalDialog.styles';

export const ModalDialog = (text: string, title?: string) => {
  S.Modal.warning({
    title: title || null,
    content: text,
    zIndex: 1002,
  });
};
